document.addEventListener('DOMContentLoaded', function () {
  const gridButtons = Array.from(document.querySelectorAll('.luxury-grid-btn'));
  let selectedColumns = window.innerWidth < 750 ? 2 : 4;

  function setButtonState(columns) {
    gridButtons.forEach(function (button) {
      const isActive = Number(button.dataset.cols) === columns;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

  function applyColumns(columns) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid || productGrid.tagName !== 'UL') return;

    productGrid.classList.remove('cols-1', 'cols-2', 'cols-3', 'cols-4');
    productGrid.classList.add('cols-' + columns);

    const oldStyle = document.getElementById('luxury-grid-override');
    if (oldStyle) oldStyle.remove();

    const computedGap = parseFloat(getComputedStyle(productGrid).columnGap) || 4;
    const totalGap = computedGap * (columns - 1);
    const style = document.createElement('style');
    style.id = 'luxury-grid-override';

    if (window.innerWidth < 750) {
      const mobileColumns = columns === 1 ? 1 : 2;
      const width = mobileColumns === 1 ? '100%' : 'calc(50% - 2px)';
      style.textContent = 'ul#product-grid.cols-' + columns + ' .grid__item {' +
        'width:' + width + '!important;' +
        'max-width:' + width + '!important;' +
        'flex:0 0 ' + width + '!important;}';
    } else {
      productGrid.className = productGrid.className.replace(/grid--\\d+-col-desktop/g, '');
      const width = 'calc((100% - ' + totalGap + 'px) / ' + columns + ')';
      style.textContent = '@media screen and (min-width:750px){' +
        'ul#product-grid.cols-' + columns + ' .grid__item {' +
        'width:' + width + '!important;' +
        'max-width:' + width + '!important;' +
        'flex:0 0 ' + width + '!important;}}';
    }

    document.head.appendChild(style);
  }

  function selectColumns(columns) {
    selectedColumns = columns;
    setButtonState(columns);
    applyColumns(columns);
  }

  gridButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      selectColumns(Number(button.dataset.cols));
    });
  });

  const productContainer = document.getElementById('ProductGridContainer');
  if (productContainer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      applyColumns(selectedColumns);
    }).observe(productContainer, { childList: true, subtree: true });
  }

  selectColumns(selectedColumns);
});
